var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 2.91667V1.75H11.6667V2.91667H10.5V4.08333H11.6667V5.25H12.8333V4.08333H14V2.91667H12.8333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66671 4.66667C5.95587 4.66667 7.00004 3.6225 7.00004 2.33333C7.00004 1.04417 5.95587 0 4.66671 0C3.37754 0 2.33337 1.04417 2.33337 2.33333C2.33337 3.6225 3.37754 4.66667 4.66671 4.66667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 5.25C3.10917 5.25 0 6.03167 0 7.58333V9.33333H9.33333V7.58333C9.33333 6.03167 6.22417 5.25 4.66667 5.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29761 0.03125C7.83427 0.649583 8.16677 1.45458 8.16677 2.33542C8.16677 3.21625 7.83427 4.02125 7.29761 4.63958C8.44094 4.49375 9.33344 3.52542 9.33344 2.33542C9.33344 1.14542 8.44094 0.177083 7.29761 0.03125Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64246 5.73438C10.1616 6.21854 10.5 6.82521 10.5 7.58354V9.33354H11.6666V7.58354C11.6666 6.73771 10.7391 6.11937 9.64246 5.73438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsers);
export default __webpack_public_path__ + "static/media/AddUsers.60872a95d8be2a86a571eb898a32449e.svg";
export { ForwardRef as ReactComponent };